import baseTheme from '../baseTheme';
var MuiDialogTitle = {
    /* your custom class style overrides here */
    root: {
        // a bit of a hack, but MUI doesn't expose it well
        // MUI normally overrides this h2 to an h6
        '& > h2': {
            fontSize: baseTheme.typography.h2.fontSize,
            fontWeight: baseTheme.typography.h2.fontWeight,
        },
    },
};
export default MuiDialogTitle;
//# sourceMappingURL=MuiDialogTitle.js.map